<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="eMulti"
            description="Indicadores para eMulti na APS"
            url="/indicadores-aps"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PessoasAtendidas from '@/components/icons/IndicadoresAps/eMulti/PessoasAtendidas'
import AcoesInterprofissionais from '@/components/icons/IndicadoresAps/eMulti/AcoesInterprofissionais'

export default {
  name: 'eMulti',
  metaInfo: {
    title: 'eMulti',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PessoasAtendidas,
    AcoesInterprofissionais,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.emulti
      ) {
        const dataClone = [...this.$store.state.permissoes.emulti]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
